import { render, staticRenderFns } from "./XkConfirmButton.vue?vue&type=template&id=696a027c&scoped=true&"
import script from "./XkConfirmButton.vue?vue&type=script&lang=js&"
export * from "./XkConfirmButton.vue?vue&type=script&lang=js&"
import style0 from "./XkConfirmButton.vue?vue&type=style&index=0&id=696a027c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696a027c",
  null
  
)

export default component.exports